
























import { Component, Vue } from 'vue-property-decorator';
import { ModalConstants } from '@/core/constants';

import { AdminModule } from '@/store/modules/admin/admin.store';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { Realmlist } from '@/types/apiServerContract';

@Component
export default class SelectRealm extends Vue {
	id: string = ModalConstants.SelectRealm;

	realms: Realmlist[] = [];

	SelectRealm(realm: Realmlist) {
	    RealmsModule.SetActiveRealm(realm.id);
	    this.$bvModal.hide(this.id);
	}

	async GetRealms() {
	    try {
	        this.realms = await AdminModule.GetRealms();
	    } catch (e) {
	        this.$bvModal.hide(this.id);
	    }
	}
}
